import React from "react";
import { useLanguage } from "../../i18n/LanguageContext";
import takvimIcon from "../../assets/takvimasset.png";
import gorevlerIcon from "../../assets/gorevlerasset.png";
import finansIcon from "../../assets/finansasset.png";
import belgelerIcon from "../../assets/belgelerasset.png";
import alisverisIcon from "../../assets/alisverisasset.png";
import harcamalarIcon from "../../assets/harcamalarasset.png";

function useReducedMotion() {
  const [reducedMotion, setReducedMotion] = React.useState(() => (
    typeof window !== "undefined"
      ? window.matchMedia("(prefers-reduced-motion: reduce)").matches
      : false
  ));

  React.useEffect(() => {
    if (typeof window === "undefined") return undefined;
    const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    const handleChange = (event) => setReducedMotion(event.matches);
    if (typeof mediaQuery.addEventListener === "function") {
      mediaQuery.addEventListener("change", handleChange);
      return () => mediaQuery.removeEventListener("change", handleChange);
    }
    mediaQuery.addListener?.(handleChange);
    return () => mediaQuery.removeListener?.(handleChange);
  }, []);

  return reducedMotion;
}

/* ── Daktilo efekti bileşeni ── */
export function TypewriterText({ text, speed = 120 }) {
  const reducedMotion = useReducedMotion();
  const [displayed, setDisplayed] = React.useState("");
  const [done, setDone]           = React.useState(false);

  React.useEffect(() => {
    if (reducedMotion) {
      setDisplayed(text);
      setDone(true);
      return undefined;
    }

    setDisplayed("");
    setDone(false);
    let i = 0;
    const timer = setInterval(() => {
      if (i < text.length) {
        setDisplayed(text.slice(0, i + 1));
        i++;
      } else {
        setDone(true);
        clearInterval(timer);
      }
    }, speed);
    return () => clearInterval(timer);
  }, [text, speed, reducedMotion]);

  return (
    <span className="authTypeText">
      {displayed}
      {!done && <span className="authTypeCursor">|</span>}
    </span>
  );
}

/* ── Aile sahnesi hareketli kartlar ── */
const AILE_SAHNELERI = [
  { ikon: takvimIcon, baslikKey: "auth.scene.calendar",  aciklamaKey: "auth.scene.calendarDesc",  renk: "#3b82f6" },
  { ikon: gorevlerIcon, baslikKey: "auth.scene.tasks",     aciklamaKey: "auth.scene.tasksDesc",     renk: "#8b5cf6" },
  { ikon: finansIcon, baslikKey: "auth.scene.finance",   aciklamaKey: "auth.scene.financeDesc",   renk: "#10b981" },
  { ikon: belgelerIcon, baslikKey: "auth.scene.documents", aciklamaKey: "auth.scene.documentsDesc", renk: "#f59e0b" },
  { ikon: alisverisIcon, baslikKey: "auth.scene.shopping",  aciklamaKey: "auth.scene.shoppingDesc",  renk: "#06b6d4" },
  { ikon: harcamalarIcon, baslikKey: "auth.scene.expenses",  aciklamaKey: "auth.scene.expensesDesc",  renk: "#ec4899" },
];

// Giriş ekranı görünür olmadan ikon indirmelerini başlatır.
if (typeof window !== "undefined") {
  AILE_SAHNELERI.forEach(({ ikon }) => {
    const image = new Image();
    image.src = ikon;
    image.decoding = "sync";
  });
}

export function AileSahnesi() {
  const { t } = useLanguage();
  const reducedMotion = useReducedMotion();
  const [aktif, setAktif] = React.useState(0);

  React.useEffect(() => {
    if (reducedMotion) {
      setAktif(0);
      return undefined;
    }
    const timer = setInterval(() => setAktif((a) => (a + 1) % AILE_SAHNELERI.length), 3600);
    return () => clearInterval(timer);
  }, [reducedMotion]);

  return (
    <div className="aileSahnesi">
      {AILE_SAHNELERI.map((s, i) => (
        <div
          key={i}
          className={`aileSahnesiKart ${aktif === i ? "aktif" : ""} ${aktif === (i + 1) % AILE_SAHNELERI.length ? "cikis" : ""}`}
          style={{ "--kart-renk": s.renk }}
        >
          <span className="aileSahnesiIkon"><img src={s.ikon} alt="" aria-hidden="true" loading="eager" decoding="sync" fetchPriority="high" /></span>
          <div>
            <div className="aileSahnesiBaslik">{t(s.baslikKey)}</div>
            <div className="aileSahnesiAciklama">{t(s.aciklamaKey)}</div>
          </div>
        </div>
      ))}
      <div className="aileSahnesiDots">
        {AILE_SAHNELERI.map((_, i) => (
          <div
            key={i}
            className={`aileSahnesiDot ${aktif === i ? "aktif" : ""}`}
            style={aktif === i ? { background: AILE_SAHNELERI[i].renk } : {}}
          />
        ))}
      </div>
    </div>
  );
}
